"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var transform_layout_children_1 = __importDefault(require("../../_helpers/transform-layout-children"));
var layout_margin_reset_1 = __importDefault(require("../../_helpers/layout-margin-reset"));
var tokens_1 = require("../../tokens");
var gutterOptions = {
    none: 0,
    xsmall: tokens_1.spacing.xsmall,
    small: tokens_1.spacing.small,
    medium: tokens_1.spacing.medium,
    large: tokens_1.spacing.xlarge
};
var galleryOptions = {
    small: 'repeat(auto-fill, minmax(150px, 1fr))',
    medium: 'repeat(auto-fill, minmax(250px, 1fr))',
    large: 'repeat(auto-fill, minmax(450px, 1fr))'
};
var GalleryLayout = function (props) { return (React.createElement(GalleryLayout.Element, __assign({}, props, automation_attribute_1.default('gallery-layout')), transform_layout_children_1.default(props, GalleryLayout.Item, 'gallery-layout.item'))); };
GalleryLayout.Element = styled_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-gap: ", ";\n\n  & > *:empty {\n    display: none;\n  }\n\n  ", ";\n"], ["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-gap: ", ";\n\n  & > *:empty {\n    display: none;\n  }\n\n  ", ";\n"])), function (props) { return galleryOptions[props.size]; }, function (props) { return gutterOptions[props.gutter]; }, layout_margin_reset_1.default());
GalleryLayout.Item = styled_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
GalleryLayout.defaultProps = {
    size: 'medium',
    gutter: 'medium'
};
exports.default = GalleryLayout;
var templateObject_1, templateObject_2;
//# sourceMappingURL=gallery-layout.js.map